// src/routes/LegacyConsultationRedirect.tsx

import { Navigate, useParams } from 'react-router-dom';

// Param-aware redirect for legacy consultation URLs.
// A plain <Navigate to="/consultation-detail/:consultationId" /> does NOT
// interpolate params — it navigates to the literal string ":consultationId".
export const LegacyConsultationRedirect: React.FC = () => {
  const { consultationId } = useParams<{ consultationId: string }>();
  return <Navigate to={`/consultation-detail/${consultationId}`} replace />;
};

export default LegacyConsultationRedirect;